export const translation = {
  ae: {
    winLabel: "Win",
    drawLabel: "Draw",
    winSumLabel: "مكاسب",
    betLink: 'ضع رهانًا',
  },
  bn: {
    winLabel: "জয়",
    drawLabel: "ড্র",
    winSumLabel: "জেতা পুরস্কার",
    betLink: 'বাজি ধরুন',
  },
  br: {
    winLabel: "Vitória,",
    drawLabel: "Empate",
    winSumLabel: "Ganhos",
    betLink: 'Fazer aposta',
  },
  de: {
    winLabel: "Sieg",
    drawLabel: "Unentschieden",
    winSumLabel: "Gewinne",
    betLink: 'Wette platzieren',
  },
  en: {
    winLabel: "Win",
    drawLabel: "Draw",
    winSumLabel: "Winnings",
    betLink: 'Place a bet',
  },
  fr: {
    winLabel: "Victoire",
    drawLabel: "Match nul",
    winSumLabel: "Gains",
    betLink: 'Placer un pari',
  },
  ir: {
    winLabel: "Win",
    drawLabel: "Draw",
    winSumLabel: "بردها",
    betLink: 'بستن شرط',
  },
  kz: {
    winLabel: "жеңіс",
    drawLabel: "Тең ойын",
    winSumLabel: "Жеңіп алу",
    betLink: 'Ұтыс тігу',
  },
  mx: {
    winLabel: "Gana",
    drawLabel: "Empata",
    winSumLabel: "Haga una apuesta",
    betLink: 'Haga una apuesta',
  },
  ru: {
    winLabel: "Победа",
    drawLabel: "Ничья",
    winSumLabel: "Твой выигрыш",
    betLink: 'Сделать ставку',
  },
  sw: {
    winLabel: "Ushindi",
    drawLabel: "Sare",
    winSumLabel: "Ushindi",
    betLink: 'Wekeza dau',
  },
  tr: {
    winLabel: "Galibiyet",
    drawLabel: "Beraberlik",
    winSumLabel: "Kazanılanlar",
    betLink: 'Bahis oyna',
  },
  ua: {
    winLabel: "Победа",
    drawLabel: "Ничья",
    winSumLabel: "Твой выигрыш",
    betLink: 'Сделать ставку',
  },
  uz: {
    winLabel: "G‘alaba",
    drawLabel: "Durang",
    winSumLabel: "Yutuq",
    betLink: 'Stavka qilish',
  },
  vi: {
    winLabel: "Thắng",
    drawLabel: "Hòa",
    winSumLabel: "Tiền thắng",
    betLink: 'Đặt cược',
  }
}